
import { defineComponent } from 'vue';
import { mapGetters, mapState } from 'vuex';
import { GlobalState } from '@/shared/models/GlobalState';

export default defineComponent({
  name: 'LoginButton',
  emits: ['close'],
  props: {
    isModalVisible: Boolean,
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
    },
    returnUrl: {
      type: String,
    },
    email: {
      type: String,
    },
    buttonClass: String,
  },
  data() {
    return {
      show: false,
    };
  },
  created() {
    this.show = this.isModalVisible;
  },
  computed: {
    ...mapState({
      user: (state) => (state as GlobalState).user,
    }),
    ...mapGetters(['isLoggedIn']),
  },
  methods: {
    showModal() {
      this.show = true;
    },
    closeModal() {
      this.show = false;
      this.$emit('close');
    },
  },
});
